"use strict"

const config = {
    baseUrl: process.env.VUE_APP_BASEURL || "http://yachts.hub.diyiqiangren.com/api/v1",
    appId: process.env.VUE_APP_APPID || "cc6e794dba4211ec819906af808612df",
    appKey: process.env.VUE_APP_APPKEY || "d1f6f306ba4211ec819906af808612df",
    timeout: process.env.VUE_APP_TIMEOUT || 30000,
    errMsg: {
        404: "没有找到路径404 \n Page does not exist 404  ",
        500: "服务器内部错误 \n Server internal error 500",
        timeout: "请求超时 \n The request timeout",
        UnKnown: "一个未知的错误 \n An unknown error has occurred",
    },
    appVersion: process.env.VUE_APP_VERSION,
    mode: process.env.NODE_ENV,
}

export default config
